import GrandRaidRankTsvRow from "Models/GrandRaidRankTsvRow";
import Tsv from "Models/Tsv";
import { IGrandRaidInfo } from "Views/GrandRaidData";
import { ITeamInfoJson } from "../Interfaces/ITeamInfoJson";

interface IExtraParse {
	teams: ITeamInfoJson,
	info: IGrandRaidInfo,
	names: {[id:string]: {
		Username: string,
		Emblem: string
	}}
}
export default class GrandRaidRankTsv extends Tsv<GrandRaidRankTsvRow> {
	// rows: GrandRaidRankTsvRow[] = [];

	parse(data:string):GrandRaidRankTsv {
		// const tsv = new GrandRaidRankTsv();
		
		const rows = data.trim().split('\n');
		for (const row of rows) {
			this.rows.push(GrandRaidRankTsvRow.parse(row));
		}
		this.raw = data;

		return this;
	}
	parseWith(data:string, extra: IExtraParse):GrandRaidRankTsv {
		// const tsv = new GrandRaidRankTsv();
		const rows = data.trim().split('\n');
		for (const row of rows) {
			const parsed = GrandRaidRankTsvRow.parse(row);
			if (!!!parsed) continue;
			parsed.correctScoreColors(extra.info);
			if (!!extra.teams && !!extra.teams[parsed.uid]) {
				parsed.withTeams(extra.teams[parsed.uid])
			}
			if (!!extra.names && !!extra.names[parsed.uid]) {
				parsed.setName(extra.names[parsed.uid].Username.replace(/^\[.+?\]/gi, ''))
				parsed.setEmblem(extra.names[parsed.uid].Emblem)
			}
			this.rows.push(parsed);
		}
		this.raw = data;

		return this;
	}
}